import { first } from 'lodash-es';
import {
  FETCH_HOST_CPU_AGGREGATE,
  FETCH_HOST_CPU_AGGREGATE_IS_ERROR,
  FETCH_HOST_CPU_AGGREGATE_IS_PENDING,
  FETCH_HOST_DISK_AGGREGATE,
  FETCH_HOST_DISK_AGGREGATE_IS_ERROR,
  FETCH_HOST_DISK_AGGREGATE_IS_PENDING,
  FETCH_HOST_MEMORY_AGGREGATE,
  FETCH_HOST_MEMORY_AGGREGATE_IS_ERROR,
  FETCH_HOST_MEMORY_AGGREGATE_IS_PENDING,
  FETCH_HOST_NETWORK_AGGREGATE,
  FETCH_HOST_NETWORK_AGGREGATE_IS_ERROR,
  FETCH_HOST_NETWORK_AGGREGATE_IS_PENDING,
  FETCH_HOST_NETWORK_UPLINK,
  FETCH_HOST_NETWORK_UPLINK_IS_ERROR,
  FETCH_HOST_NETWORK_UPLINK_IS_PENDING,
  FETCH_HOST_STATUS,
  FETCH_HOST_STATUS_IS_ERROR,
  FETCH_HOST_STATUS_IS_PENDING,
  HostActions,
  HostReducerState,
  RESET_REDUCER,
} from 'services/Telemetry/Host/types';

const INITIAL_STATE = {
  fetchHostStatusIsCompleted: false,
  fetchHostStatusIsPending: false,
  fetchHostStatusIsError: null,
  hostMemoryAggregate: {},
  fetchHostMemoryAggregateIsCompleted: false,
  fetchHostMemoryAggregateIsPending: false,
  fetchHostMemoryAggregateIsError: null,
  hostCPUAggregate: {},
  fetchHostCPUAggregateIsCompleted: false,
  fetchHostCPUAggregateIsPending: false,
  fetchHostCPUAggregateIsError: null,
  hostDiskAggregate: {},
  fetchHostDiskAggregateIsCompleted: false,
  fetchHostDiskAggregateIsPending: false,
  fetchHostDiskAggregateIsError: null,
  hostNetworkAggregate: {},
  fetchHostNetworkAggregateIsCompleted: false,
  fetchHostNetworkAggregateIsPending: false,
  fetchHostNetworkAggregateIsError: null,
  upLinks: {},
  fetchHostNetworkUplinkIsCompleted: false,
  fetchHostNetworkUplinkIsPending: false,
  fetchHostNetworkUplinkIsError: null,
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,
  hosts: undefined,
} satisfies HostReducerState;

const telemetryHostReducer = (previousState: HostReducerState | undefined, action: HostActions) => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_HOST_STATUS:
      return {
        ...state,
        hostStatusAggregate: action.data,
        fetchHostStatusIsCompleted: true,
        fetchHostStatusIsPending: false,
        fetchHostStatusIsError: null,
      };
    case FETCH_HOST_STATUS_IS_PENDING:
      return {
        ...state,
        fetchHostStatusIsCompleted: false,
        fetchHostStatusIsPending: true,
        fetchHostStatusIsError: null,
      };
    case FETCH_HOST_STATUS_IS_ERROR:
      return {
        ...state,
        fetchHostStatusIsCompleted: true,
        fetchHostStatusIsPending: false,
        fetchHostStatusIsError: action.error,
      };
    case FETCH_HOST_MEMORY_AGGREGATE:
      return {
        ...state,
        hostMemoryAggregate: action.data,
        fetchHostMemoryAggregateIsCompleted: true,
        fetchHostMemoryAggregateIsPending: false,
        fetchHostMemoryAggregateIsError: null,
      };
    case FETCH_HOST_MEMORY_AGGREGATE_IS_PENDING:
      return {
        ...state,
        fetchHostMemoryAggregateIsCompleted: false,
        fetchHostMemoryAggregateIsPending: true,
        fetchHostMemoryAggregateIsError: null,
      };
    case FETCH_HOST_MEMORY_AGGREGATE_IS_ERROR:
      return {
        ...state,
        fetchHostMemoryAggregateIsCompleted: true,
        fetchHostMemoryAggregateIsPending: false,
        fetchHostMemoryAggregateIsError: action.error,
      };
    case FETCH_HOST_CPU_AGGREGATE:
      return {
        ...state,
        hostCPUAggregate: action.data,
        fetchHostCPUAggregateIsCompleted: true,
        fetchHostCPUAggregateIsPending: false,
        fetchHostCPUAggregateIsError: null,
      };
    case FETCH_HOST_CPU_AGGREGATE_IS_PENDING:
      return {
        ...state,
        fetchHostCPUAggregateIsCompleted: false,
        fetchHostCPUAggregateIsPending: true,
        fetchHostCPUAggregateIsError: null,
      };
    case FETCH_HOST_CPU_AGGREGATE_IS_ERROR:
      return {
        ...state,
        fetchHostCPUAggregateIsCompleted: true,
        fetchHostCPUAggregateIsPending: false,
        fetchHostCPUAggregateIsError: action.error,
      };
    case FETCH_HOST_DISK_AGGREGATE:
      return {
        ...state,
        hostDiskAggregate: action.data,
        fetchHostDiskAggregateIsCompleted: true,
        fetchHostDiskAggregateIsPending: false,
        fetchHostDiskAggregateIsError: null,
      };
    case FETCH_HOST_DISK_AGGREGATE_IS_PENDING:
      return {
        ...state,
        fetchHostDiskAggregateIsCompleted: false,
        fetchHostDiskAggregateIsPending: true,
        fetchHostDiskAggregateIsError: null,
      };
    case FETCH_HOST_DISK_AGGREGATE_IS_ERROR:
      return {
        ...state,
        fetchHostDiskAggregateIsCompleted: true,
        fetchHostCPUAggregateIsPending: false,
        fetchHostDiskAggregateIsError: action.error,
      };
    case FETCH_HOST_NETWORK_AGGREGATE:
      return {
        ...state,
        hostNetworkAggregate: action.data,
        fetchHostNetworkAggregateIsCompleted: true,
        fetchHostNetworkAggregateIsPending: false,
        fetchHostNetworkAggregateIsError: null,
      };
    case FETCH_HOST_NETWORK_AGGREGATE_IS_PENDING:
      return {
        ...state,
        fetchHostNetworkAggregateIsCompleted: false,
        fetchHostNetworkAggregateIsPending: true,
        fetchHostNetworkAggregateIsError: null,
      };
    case FETCH_HOST_NETWORK_AGGREGATE_IS_ERROR:
      return {
        ...state,
        fetchHostNetworkAggregateIsCompleted: true,
        fetchHostNetworkAggregateIsPending: false,
        fetchHostNetworkAggregateIsError: action.error,
      };

    case FETCH_HOST_NETWORK_UPLINK: {
      const upLink = first(action.data);

      return {
        ...state,
        upLinks: {
          ...state.upLinks,
          [action.uplinkId]: upLink,
        },
        fetchHostNetworkUplinkIsCompleted: true,
        fetchHostNetworkUplinkIsPending: false,
        fetchHostNetworkUplinkIsError: null,
      };
    }

    case FETCH_HOST_NETWORK_UPLINK_IS_PENDING:
      return {
        ...state,
        fetchHostNetworkUplinkIsCompleted: false,
        fetchHostNetworkUplinkIsPending: true,
        fetchHostNetworkUplinkIsError: null,
      };
    case FETCH_HOST_NETWORK_UPLINK_IS_ERROR:
      return {
        ...state,
        fetchHostNetworkUplinkIsCompleted: true,
        fetchHostNetworkUplinkIsPending: false,
        fetchHostNetworkUplinkIsError: action.error,
      };

    case RESET_REDUCER:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default telemetryHostReducer;
